import { GamesStorageType } from './types';

export const gameStoreInitialState: GamesStorageType = {
  // <> new plex cms api
  lobbies: {
    casino: {},
    casinoLive: {},
    instantGames: {}
  },
  pagination: {
    category: {},
    provider: {},
    search: {}
  },
  // </> new plex cms api
  feeds: {},
  games: {
    data: {},
    launchIdToGameId: {},
    ids: []
  },
  providers: {
    data: {},
    serviceIdToProviderId: {}
  },
  excludedActiveBonusGamesList: {
    data: null,
    isAlreadyBeenRequested: false
  },
  favorites: {},
  recentlyPlayed: {},
  recommendedGames: {},
  dynamicCategories: {
    wagerSlotGames: {},
    liveRtpGames: {}
  },
  gamesLiveInfo: {
    isCmsPragmaticLiveDataLoaded: false,
    launchIdToGameLiveData: {},
    // for pragmatic live-updates we need mapper to associate innerProviderId from getInnerGamesIds with a game launchId
    // will be removed when pragmatic live-updates are added to a new API
    innerGameIdToLaunchId: {}
  },
  jackpots: {}
};
